"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = require("coveo-search-ui");
var ContextEvents_1 = require("../../events/ContextEvents");
var CoveoForSitecoreContext = (function (_super) {
    __extends(CoveoForSitecoreContext, _super);
    function CoveoForSitecoreContext(element, options, bindings) {
        var _this = _super.call(this, element, CoveoForSitecoreContext.ID, bindings) || this;
        _this.element = element;
        _this.options = options;
        _this.bindings = bindings;
        _this.options = coveo_search_ui_1.ComponentOptions.initComponentOptions(element, CoveoForSitecoreContext, options);
        _this.bind.onRootElement(coveo_search_ui_1.InitializationEvents.afterComponentsInitialization, _this.afterComponentsInitialization);
        _this.bind.onRootElement(coveo_search_ui_1.QueryEvents.doneBuildingQuery, _this.doneBuildingQuery);
        return _this;
    }
    CoveoForSitecoreContext.prototype.doneBuildingQuery = function (args) {
        if (this.hasDefaultPipelineNameSet() && this.queryBuilderUsesDefaultPipeline(args.queryBuilder)) {
            args.queryBuilder.pipeline = this.options.scDefaultPipelineName;
        }
    };
    CoveoForSitecoreContext.prototype.hasDefaultPipelineNameSet = function () {
        return this.options.scDefaultPipelineName !== "";
    };
    CoveoForSitecoreContext.prototype.queryBuilderUsesDefaultPipeline = function (queryBuilder) {
        return typeof (queryBuilder.pipeline) === "undefined";
    };
    CoveoForSitecoreContext.prototype.afterComponentsInitialization = function () {
        var contextArgs = {
            sitecoreItemUri: this.options.scItemUri,
            sitecorePageName: this.options.scPageName,
            analyticsEnabled: this.options.scAnalyticsEnabled,
            indexSourceName: this.options.scIndexSourceName,
            currentLanguage: this.options.scCurrentLanguage,
            languageFieldName: this.options.scLanguageFieldName,
            latestVersionFieldName: this.options.scLatestVersionFieldName
        };
        this.bind.trigger(this.element, ContextEvents_1.SitecoreContextEvents.onSitecoreContextInitialization, contextArgs);
    };
    return CoveoForSitecoreContext;
}(coveo_search_ui_1.Component));
CoveoForSitecoreContext.ID = "ForSitecoreContext";
CoveoForSitecoreContext.options = {
    scItemUri: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scLanguageFieldName: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scLatestVersionFieldName: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scCurrentLanguage: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scRestEndpointUri: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scLabels: coveo_search_ui_1.ComponentOptions.buildJsonOption(),
    scPageName: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scDefaultPipelineName: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scAnalyticsEnabled: coveo_search_ui_1.ComponentOptions.buildBooleanOption(),
    scIsUserAnonymous: coveo_search_ui_1.ComponentOptions.buildBooleanOption(),
    scFieldPrefix: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scFieldSuffix: coveo_search_ui_1.ComponentOptions.buildStringOption(),
    scExternalFields: coveo_search_ui_1.ComponentOptions.buildJsonOption(),
    scIndexSourceName: coveo_search_ui_1.ComponentOptions.buildStringOption()
};
exports.CoveoForSitecoreContext = CoveoForSitecoreContext;
coveo_search_ui_1.Initialization.registerAutoCreateComponent(CoveoForSitecoreContext);



//////////////////
// WEBPACK FOOTER
// ./src/ui/context/CoveoForSitecoreContext.ts
// module id = 5
// module chunks = 13 14